import {Component, input, InputSignal, output} from '@angular/core';
import {LabelComponent} from '../../../../../../../common/label/label.component';
import {CommonModule} from '@angular/common';
import {ParcelAppEntityParcelWrite} from '../../../../../../../openapi';

@Component({
  selector: 'app-parcels-preview',
  standalone: true,
  imports: [
    LabelComponent,
    CommonModule
  ],
  templateUrl: './parcels-preview.component.html'
})
export class ParcelsPreviewComponent {

  public showActions = input(false);

  public canEdit = input(true);

  public parcels: InputSignal<ParcelAppEntityParcelWrite[]> = input<ParcelAppEntityParcelWrite[]>([]);

  public onRemove = output<number>();

  public onEdit = output<{ v: ParcelAppEntityParcelWrite, i: number }>();

}
